import { ButtonLink } from '../ui/Button'
import { Card, SectionTitle } from '../ui/Card'

export function QuickActionsWidget() {
  return (
    <Card>
      <SectionTitle>Quick Actions</SectionTitle>
      <div className="flex gap-3 flex-wrap">
        <ButtonLink to="/clients/new">+ Add Client</ButtonLink>
        <ButtonLink to="/clients" variant="outline">View All Clients</ButtonLink>
      </div>
    </Card>
  )
}
